import { type BrandAlias } from '@jotta/config/brand'
import type { PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

interface ThemeContextValue<T extends BrandAlias> {
  brandAlias: T
}

const defaultContextValue: ThemeContextValue<'test'> = {
  brandAlias: 'test',
}
export const ThemeContext =
  createContext<ThemeContextValue<BrandAlias>>(defaultContextValue)
export function ThemeContextProvider({
  brandAlias,
  children,
}: PropsWithChildren<{ brandAlias: BrandAlias }>) {
  return (
    <ThemeContext.Provider
      value={{
        brandAlias,
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export function useThemeContext() {
  return useContext(ThemeContext)
}
